import {AbstractModel} from '../abstract-model';
import {PartnerTypesStat} from './partner-types-stat';
import {ProductStat} from './product-stat';
import {SiteStat} from './site-stat';
import {TopPartnerStat} from './top-partner-stat';

export class HomeStat extends AbstractModel {
  partnerTypes: PartnerTypesStat | null = null;
  products: ProductStat[] | null = null;
  sites: SiteStat[] | null = null;
  topAffiliates: TopPartnerStat[] | null = null;
  topMediabuyers: TopPartnerStat[] | null = null;
}
